/* ============================================================================
   drb-annonce.js — module d'annonce Claripharm : bandeau déroulant (B) + fenêtre (C)
   Intégrateur B, 21/09/2026. Aucune dépendance, rien ici ne doit aller dans drb-portal.js.
   Chargé en defer depuis layout/theme.liquid ; le HTML vient de snippets/drb-annonce.liquid.

   Bandeau : compte à rebours vers le 01/10/2026 (data-bascule), vitesse ~60 px/s calculée
   sur la largeur réelle de la piste, fermeture retenue (localStorage drb_annonce_v1),
   retrait si la borne data-fin est passée (page servie depuis le cache).
   Fenêtre  : 6 s après DOMContentLoaded, une fois par visiteur (localStorage drb_modale_v1
   posée DÈS l'affichage), fermeture croix / surcouche / Échap / « Plus tard », focus sur la
   boîte à l'ouverture et rendu au body à la fermeture, retrait si data-fin est passée.

   Test de date : définir window.__drbAnnonceNow (ISO « 2026-10-01T09:00:00 » ou ms) AVANT
   ce script (Playwright : add_init_script). Il remplace la date courante partout ici.
   ============================================================================ */
(function () {
  'use strict';

  var CLE_BANDEAU = 'drb_annonce_v2';
  var CLE_MODALE = 'drb_modale_v2';
  var VITESSE_PX_S = 32;
  var DELAI_MODALE_MS = 6000;
  var JOUR_MS = 86400000;

  function maintenant() {
    var s = window.__drbAnnonceNow;
    if (s !== undefined && s !== null) {
      var d = new Date(s);
      if (!isNaN(d.getTime())) { return d; }
    }
    return new Date();
  }

  /* « AAAA-MM-JJ » -> minuit local de ce jour */
  function minuitLocal(iso) {
    var p = String(iso || '').split('-');
    if (p.length !== 3) { return null; }
    return new Date(+p[0], +p[1] - 1, +p[2], 0, 0, 0, 0);
  }

  function lire(cle) {
    try { return window.localStorage.getItem(cle); } catch (e) { return null; }
  }
  function ecrire(cle, valeur) {
    try { window.localStorage.setItem(cle, valeur); } catch (e) { /* stockage indisponible : on affiche quand même */ }
  }

  /* ---------------- B · bandeau ---------------- */
  function bandeau() {
    var el = document.querySelector('[data-drb-annonce]');
    if (!el) { return; }

    var now = maintenant();
    var fin = minuitLocal(el.getAttribute('data-fin'));
    if (lire(CLE_BANDEAU) || (fin && now >= fin)) { el.parentNode.removeChild(el); return; }

    /* compte à rebours, recalculé côté client (le Liquid n'est qu'un repli) */
    var bascule = minuitLocal(el.getAttribute('data-bascule'));
    if (bascule) {
      var n = Math.ceil((bascule.getTime() - now.getTime()) / JOUR_MS);
      var libelle = n > 1 ? 'Culottes menstruelles remboursées dans ' + n + ' jours'
                  : n === 1 ? 'Culottes menstruelles remboursées dans 1 jour'
                  : 'Remboursées depuis le 1er octobre · réassort à l\'unité';
      var cibles = el.querySelectorAll('[data-drb-annonce-cr]');
      for (var i = 0; i < cibles.length; i++) { cibles[i].textContent = libelle; }
    }

    /* défilement : uniquement si le mouvement est accepté ; durée = largeur / 60 px/s */
    var reduit = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var liste = el.querySelector('.drb-annonce__list');
    function regler() {
      if (reduit || !liste) { return; }
      var largeur = liste.getBoundingClientRect().width;
      if (largeur > 0) {
        el.style.setProperty('--drb-annonce-duree', (largeur / VITESSE_PX_S).toFixed(2) + 's');
        el.classList.add('is-anime');
      }
    }
    regler();
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(regler); /* la largeur change quand DM Sans arrive */
    }

    var fermer = el.querySelector('[data-drb-annonce-fermer]');
    if (fermer) {
      fermer.addEventListener('click', function () {
        ecrire(CLE_BANDEAU, String(Date.now()));
        if (el.parentNode) { el.parentNode.removeChild(el); }
      });
    }
  }

  /* ---------------- C · fenêtre au premier chargement ---------------- */
  function modale() {
    var el = document.querySelector('[data-drb-modale]');
    if (!el) { return; }

    var now = maintenant();
    var fin = minuitLocal(el.getAttribute('data-fin'));
    if (lire(CLE_MODALE) || (fin && now >= fin)) { el.parentNode.removeChild(el); return; }

    var boite = el.querySelector('[data-drb-modale-boite]');
    if (!boite) { return; }
    var ouverte = false;

    function fermer() {
      if (!ouverte) { return; }
      ouverte = false;
      document.removeEventListener('keydown', surClavier, true);
      el.hidden = true;
      if (document.activeElement && document.activeElement.blur) { document.activeElement.blur(); }
      if (el.parentNode) { el.parentNode.removeChild(el); }
      /* l'élément actif redevient le body */
    }

    function surClavier(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); fermer(); return; }
      if (e.key === 'Tab') {
        var f = boite.querySelectorAll('a[href], button:not([disabled])');
        if (!f.length) { return; }
        var premier = f[0], dernier = f[f.length - 1], actif = document.activeElement;
        if (e.shiftKey && (actif === premier || actif === boite)) { e.preventDefault(); dernier.focus(); }
        else if (!e.shiftKey && actif === dernier) { e.preventDefault(); premier.focus(); }
        else if (!boite.contains(actif)) { e.preventDefault(); premier.focus(); }
      }
    }

    function ouvrir() {
      if (lire(CLE_MODALE)) { if (el.parentNode) { el.parentNode.removeChild(el); } return; } /* un autre onglet l'a montrée entre-temps */
      ecrire(CLE_MODALE, String(Date.now()));   /* posée DÈS l'affichage, pas à la fermeture */
      el.hidden = false;
      ouverte = true;
      boite.focus();
      document.addEventListener('keydown', surClavier, true);
    }

    var fermetures = el.querySelectorAll('[data-drb-modale-fermer]');
    for (var i = 0; i < fermetures.length; i++) { fermetures[i].addEventListener('click', fermer); }

    /* audit-12-points-2026-10-06 : ouverture après la 1re interaction (défilement ou appui) et au moins 6 s après l'arrivée.
       Le navigateur cesse de mesurer le LCP à la 1re interaction : le visuel de la fenêtre ne compte plus comme
       « plus grand élément » de la page (6,4 s mesurées sur mobile et tablette avant ce correctif). */
    var visuel = el.querySelector('img[loading="lazy"]');
    var depart = Date.now(), lance = false;
    function enSaisie() { var a = document.activeElement; return !!(a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.tagName === 'SELECT' || a.isContentEditable)); }
    function tenter() { if (enSaisie()) { window.setTimeout(tenter, 3000); return; } ouvrir(); }
    function surInteraction(e) {
      if (lance) { return; }
      if (e && e.type === 'scroll' && (window.scrollY || 0) < 120) { return; }
      lance = true;
      window.removeEventListener('scroll', surInteraction); window.removeEventListener('pointerdown', surInteraction);
      if (visuel) { visuel.loading = 'eager'; }
      window.setTimeout(tenter, Math.max(1500, DELAI_MODALE_MS - (Date.now() - depart)));
    }
    window.addEventListener('scroll', surInteraction, { passive: true });
    window.addEventListener('pointerdown', surInteraction, { passive: true });
  }

  function demarrer() { bandeau(); modale(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
